import { useFetch } from './index';
import services from '../services';

export const useGetRelateInfo = (listId) =>{
  return useFetch(services.RelateInfo.getRelateInfo, listId);
}
